import { merge } from 'ramda';
import { Socket } from 'phoenix';

export const bindChannelToStore = (store) => {
  var channelState = { email: null, loggedIn: false, socket: null, channel: null };
  
  console.log("binding channel to store", store);

  store.subscribe( () => {
    const state = store.getState();
    var authChanged = false;
    
    console.log("got state", state);
    if (!state) { return; }
    if (state.session.session.logged_in && (state.session.session.user.email !== channelState.email)) {
      channelState.email = state.session.session.user.email;
      authChanged = true;
      console.log("switching to user", channelState.email);
    }

    if (!authChanged) { return; }

    if (channelState.channel) { channelState.channel.leave(); }
    let socket = new Socket("/socket", {params: {userToken: channelState.email}});
    socket.connect();
    let channel = socket.channel("model:changes");
    channel.on("update", msg => {
      console.log("Got message", msg);
      store.dispatch({type: `live/${msg.type}`, payload: msg.model, meta: {}});
    });
    channel.join()
           .receive("ok", resp => { console.log("Joined successfully", resp)})
           .receive("error", resp => { console.log("Unable to join", resp)});
    channelState = merge(channelState, { socket, channel });
  });
};



// WEBPACK FOOTER //
// ./src/channels.js